// -----------------------------------------------------------------------------
// Demo modal: links with data-demo="<embed URL>", and plain Storylane links
// (storylane.io/share/… or /demo/…, e.g. in body copy), open the demo in a
// dialog instead of following the link. The iframe loads on open and is
// cleared on close. Where Cookiebot runs and marketing consent hasn't been given,
// the dialog asks for it and links out to the demo instead.
// -----------------------------------------------------------------------------

let modal = null;
let opener = null;

const hasConsent = () => !window.Cookiebot || Boolean(window.Cookiebot.consent?.marketing);

const createModal = () => {
  const dialog = document.createElement('dialog');

  dialog.className = 'demo-modal';
  dialog.setAttribute('aria-label', 'Interactive demo');
  dialog.innerHTML = `
    <div class="demo-modal-inner">
      <button type="button" class="demo-modal-close icon-close" aria-label="Close the interactive demo"></button>
      <div class="demo-modal-frame"></div>
    </div>`;
  document.body.append(dialog);

  dialog.querySelector('.demo-modal-close').addEventListener('click', () => dialog.close());

  // A click on the backdrop closes it
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  dialog.addEventListener('close', () => {
    dialog.querySelector('.demo-modal-frame').replaceChildren();
    opener?.focus();
  });

  return dialog;
};

const fillFrame = (frame, src, href) => {
  if (hasConsent()) {
    const iframe = document.createElement('iframe');

    iframe.src = src;
    iframe.title = 'Interactive demo';
    iframe.allow = 'fullscreen';

    // The embed takes focus when it loads, which would swallow Escape: keep focus on the close button until the
    // visitor clicks into the demo
    iframe.addEventListener('load', () => {
      if (document.activeElement === iframe) {
        modal.querySelector('.demo-modal-close').focus();
      }
    });
    frame.replaceChildren(iframe);
    return;
  }

  const notice = document.createElement('div');

  notice.className = 'demo-modal-consent';
  notice.innerHTML = `
    <p>This demo is hosted on Storylane, which sets cookies.</p>
    <button type="button" class="btn">Accept marketing cookies to view</button>
    <a target="_blank" rel="noopener">Open the demo in a new tab</a>`;
  notice.querySelector('a').href = href;
  notice.querySelector('button').addEventListener('click', () => {
    window.addEventListener('CookiebotOnAccept', () => fillFrame(frame, src, href), { once: true });
    window.Cookiebot.renew();
  });
  frame.replaceChildren(notice);
};

// The inline embed URL for a link: its data-demo, or the Storylane demo it points to
const embedUrl = (link) => {
  if (link.dataset.demo) {
    return link.dataset.demo;
  }

  const id = link.href.match(/storylane\.io\/(?:share|demo)\/([\w-]+)/)?.[1];

  return id ? `https://app.storylane.io/demo/${id}?embed=inline` : '';
};

export default (link) => {
  const src = embedUrl(link);

  if (!src) {
    return;
  }

  link.setAttribute('aria-haspopup', 'dialog');
  link.addEventListener('click', (event) => {
    event.preventDefault();
    modal = modal || createModal();
    opener = link;
    fillFrame(modal.querySelector('.demo-modal-frame'), src, link.getAttribute('href') || src);
    modal.showModal();
    modal.querySelector('.demo-modal-close').focus();
  });
};
